import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCode20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCode20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.561 14.5a.75.75 0 0 1-1.06 0l-3.97-3.97L1 10l.53-.53L5.5 5.5a.75.75 0 1 1 1.061 1.06L3.121 10l3.44 3.44a.75.75 0 0 1 0 1.06m6.88-9a.75.75 0 0 1 1.061 0l3.97 3.97.53.53-.53.53-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.44-3.44-3.44-3.44a.75.75 0 0 1 0-1.06m-1.197.825a.75.75 0 0 0-1.4-.538L7.86 13.56a.75.75 0 0 0 1.4.538z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCode20);
